function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, HStack, Heading, Icon, IconButton, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useBreakpoint } from '@chakra-ui/react';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
function DynamicDrawer(_param) {
    var title = _param.title, children = _param.children, footer = _param.footer, onClose = _param.onClose, bodyProps = _param.bodyProps, rest = _object_without_properties(_param, [
        "title",
        "children",
        "footer",
        "onClose",
        "bodyProps"
    ]);
    var intl = useIntl();
    var breakpoint = useBreakpoint();
    var showDrawer = breakpoint === 'base' || breakpoint === 'sm';
    if (showDrawer) {
        return /*#__PURE__*/ _jsxs(Drawer, _object_spread_props(_object_spread({
            placement: "right",
            size: "md",
            onClose: onClose
        }, rest), {
            children: [
                /*#__PURE__*/ _jsx(DrawerOverlay, {}),
                /*#__PURE__*/ _jsxs(DrawerContent, {
                    bgColor: "backgroundPrimary",
                    children: [
                        /*#__PURE__*/ _jsxs(DrawerHeader, {
                            as: HStack,
                            justifyContent: "space-between",
                            p: 4,
                            borderBottomWidth: 1,
                            borderColor: "borderTertiary",
                            children: [
                                /*#__PURE__*/ _jsx(Heading, {
                                    size: "md",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(IconButton, {
                                    variant: "ghost",
                                    "aria-label": intl.formatMessage({
                                        id: "rbrahO",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Close"
                                            }
                                        ]
                                    }),
                                    icon: /*#__PURE__*/ _jsx(Icon, {
                                        as: FontAwesomeIcon,
                                        icon: faClose
                                    }),
                                    onClick: onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DrawerBody, _object_spread_props(_object_spread({
                            display: "flex",
                            flexDir: "column",
                            p: 4
                        }, bodyProps), {
                            children: children
                        })),
                        footer != null ? /*#__PURE__*/ _jsx(DrawerFooter, {
                            gap: 4,
                            borderTopWidth: 1,
                            borderColor: "borderTertiary",
                            padding: 4,
                            children: footer
                        }) : null
                    ]
                })
            ]
        }));
    }
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({
        size: "lg",
        onClose: onClose,
        isCentered: true
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsxs(ModalContent, {
                bgColor: "backgroundPrimary",
                children: [
                    /*#__PURE__*/ _jsxs(ModalHeader, {
                        as: HStack,
                        justifyContent: "space-between",
                        px: 6,
                        py: 4,
                        borderBottomWidth: 1,
                        borderColor: "borderTertiary",
                        children: [
                            /*#__PURE__*/ _jsx(Heading, {
                                size: "md",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                variant: "ghost",
                                "aria-label": intl.formatMessage({
                                    id: "rbrahO",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Close"
                                        }
                                    ]
                                }),
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faClose
                                }),
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ModalBody, _object_spread_props(_object_spread({
                        display: "flex",
                        flexDir: "column",
                        p: 6
                    }, bodyProps), {
                        children: children
                    })),
                    footer != null ? /*#__PURE__*/ _jsx(ModalFooter, {
                        gap: 6,
                        borderTopWidth: 1,
                        borderColor: "borderTertiary",
                        padding: 6,
                        children: footer
                    }) : null
                ]
            })
        ]
    }));
}
export default DynamicDrawer;
